module.exports = __webpack_public_path__ + "static/access-8c54a7ac9c26fe30c3569336e53a898d.png";